import { API } from 'api';
import { useMutation } from 'react-query';

interface IResetPoints {
  payload: {
    fromEid: string;
    fromEbid?: string;
    description?: string;
  };
}

export const resetPoints = (payload: IResetPoints['payload']) => API.post()(`/api/admin/reward/reset`, payload);

export const useResetPoints = () =>
  useMutation(resetPoints, {
    onSuccess: (response) => response.data,
  });
